import React from 'react';

const HeaderSubmenu = ({ children, onMouseOut, onMouseOver, rootPath }) => (
  <header className="bg-yellow-2 white fixed top-1 full-width" onMouseOut={onMouseOut} onMouseOver={onMouseOver} >
    <div className="clearfix max-width-4 mx-auto px1">
      <div className="left a-desktop-pop-logo xs-hide sm-hide" title="Pop logo">
        <a className="a-inner-link" href={rootPath} />
      </div>
      {children}
    </div>
  </header>
);

export default HeaderSubmenu;
